import React from 'react';
import { WrenchIcon, BarChart, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../lib/seo';

const Maintenance: React.FC = () => {
  const { t } = useTranslation();

  const preventiveItems = [
    t('maintenancePage.services.preventive.items.0'),
    t('maintenancePage.services.preventive.items.1'),
    t('maintenancePage.services.preventive.items.2'),
    t('maintenancePage.services.preventive.items.3'),
    t('maintenancePage.services.preventive.items.4')
  ];

  const correctiveItems = [
    t('maintenancePage.services.corrective.items.0'),
    t('maintenancePage.services.corrective.items.1'),
    t('maintenancePage.services.corrective.items.2'),
    t('maintenancePage.services.corrective.items.3'),
    t('maintenancePage.services.corrective.items.4')
  ];

  const quarterlyItems = [
    t('maintenancePage.plans.quarterly.items.0'),
    t('maintenancePage.plans.quarterly.items.1'),
    t('maintenancePage.plans.quarterly.items.2'),
    t('maintenancePage.plans.quarterly.items.3')
  ];

  const semiAnnualItems = [
    t('maintenancePage.plans.semiAnnual.items.0'),
    t('maintenancePage.plans.semiAnnual.items.1'),
    t('maintenancePage.plans.semiAnnual.items.2'),
    t('maintenancePage.plans.semiAnnual.items.3')
  ];

  const annualItems = [
    t('maintenancePage.plans.annual.items.0'),
    t('maintenancePage.plans.annual.items.1'),
    t('maintenancePage.plans.annual.items.2'),
    t('maintenancePage.plans.annual.items.3')
  ];

  return (
    <>
      <SEO 
        title="Mantenimiento Eléctrico Barcelona | Servicio Profesional"
        description="Servicio de mantenimiento eléctrico profesional en Barcelona. Mantenimiento preventivo y correctivo, optimización de sistemas y servicio programado."
        canonical="/maintenance"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{t('maintenancePage.title')}</h1>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 p-6 rounded-lg">
              <WrenchIcon className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('maintenancePage.features.preventive.title')}</h3>
              <p>{t('maintenancePage.features.preventive.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <BarChart className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('maintenancePage.features.optimization.title')}</h3>
              <p>{t('maintenancePage.features.optimization.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <Calendar className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('maintenancePage.features.scheduled.title')}</h3>
              <p>{t('maintenancePage.features.scheduled.description')}</p>
            </div>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-3xl font-bold mb-6">{t('maintenancePage.services.title')}</h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-xl font-bold mb-4">{t('maintenancePage.services.preventive.title')}</h3>
                <ul className="space-y-2">
                  {preventiveItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('maintenancePage.services.corrective.title')}</h3>
                <ul className="space-y-2">
                  {correctiveItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 p-8 rounded-lg mb-12">
              <h2 className="text-3xl font-bold mb-6">{t('maintenancePage.plans.title')}</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('maintenancePage.plans.quarterly.title')}</h3>
                  <ul className="space-y-2">
                    {quarterlyItems.map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('maintenancePage.plans.semiAnnual.title')}</h3>
                  <ul className="space-y-2">
                    {semiAnnualItems.map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('maintenancePage.plans.annual.title')}</h3>
                  <ul className="space-y-2">
                    {annualItems.map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;